<div class="ajax-loading ajax-popup-loading"><div class="loading-icon"></div></div>
<div class="mat-dialog-title" mat-dialog-title="">
    <h2>{{claim.id != null && claim.id.length > 0 ? "Edit Claim" : "Add Claim"}}</h2>
    <button mat-button mat-dialog-close class="close">Cancel</button>
</div>
<form (ngSubmit)="saveClaim()">
    <div mat-dialog-content class="example-container">
        <div class="row m-t-10">
            <div class="col-md-4 m-t-15">
                <span class="form-label">Code </span><span class="required">*</span>
            </div>
            <div class="col-md-8">
                <mat-form-field>
                    <input matInput type="text" maxlength="50" placeholder="Code"
                            [formControl]="code" name="code" [(ngModel)]="claim.code" />
                    <mat-error *ngIf="code.invalid">Code is required</mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="row m-t-10">
            <div class="col-md-4 m-t-15">
                <span class="form-label">Description </span><span class="required">*</span>
            </div>
            <div class="col-md-8">
                <mat-form-field>
                    <input matInput type="text" maxlength="100" placeholder="Description"
                            [formControl]="description" name="description" [(ngModel)]="claim.description" />
                    <mat-error *ngIf="description.invalid">Description is required</mat-error>
                </mat-form-field>
            </div>
        </div>
    </div>
    <div mat-dialog-actions class="row">
        <div class="col-12">
            <div class="text-center pt-3 pb-4 d-flex  justify-content-center"> 
                <button mat-raised-button color="primary" type="submit" class="oms-btn me-3">Save </button>&nbsp;&nbsp;
                <button mat-raised-button color="primary" (click)="closeDialog()" type="button" class="oms-btn-primary">Cancel </button>
            </div>
        </div>
    </div>
</form>
